/**
 * Leyenda de colores para citas pendientes con historial de inasistencias.
 */
export default function AppointmentBookingLegend({ title = 'Leyenda de colores' }) {
  return (
    <div
      className="rounded-lg border border-border bg-muted/30 px-4 py-3 text-sm"
      role="note"
      aria-label="Leyenda de colores en citas pendientes"
    >
      <p className="font-medium text-foreground mb-2">{title}</p>
      <ul className="space-y-2 text-muted-foreground">
        <li className="flex items-start gap-3">
          <span
            className="mt-0.5 inline-block w-10 h-5 shrink-0 rounded border-2 border-amber-400/65 bg-amber-50/90 dark:bg-amber-950/30"
            aria-hidden
          />
          <span>
            <strong className="text-foreground font-medium">Fondo ámbar claro:</strong> el teléfono tiene
            inasistencia(s) previa(s). Revise el nombre antes de confirmar.
          </span>
        </li>
        <li className="flex items-start gap-3">
          <span
            className="mt-0.5 inline-block w-10 h-5 shrink-0 rounded border-2 border-amber-500/75 bg-amber-100/90 dark:bg-amber-950/50"
            aria-hidden
          />
          <span>
            <strong className="text-foreground font-medium">Fondo ámbar intenso:</strong> alcanzó el límite de
            inasistencias; el paciente debe pagar la transferencia configurada en Ajustes (sigue pudiendo agendar por
            WhatsApp).
          </span>
        </li>
        <li>Fila sin color: teléfono sin inasistencias registradas.</li>
        <li>
          Etiqueta «Asistencia sin confirmar»: ya se envió el recordatorio matutino y el paciente aún no respondió
          *1* o *SÍ* por WhatsApp.
        </li>
      </ul>
    </div>
  );
}
